/**
 * Toolbox class used for Ids generator and helpers
 */
export class IdUtils {
    /**
     * Generates an UUID (Universal Unique Identifier)
     * based on RFC 4122
     * @returns {string}
     */
    public static generateUUID(): string {
        const cryptoObject = IdUtils.getCryptoObject();
        const lut = [...Array(256)].map((v, i) => (i < 16 ? '0' : '') + i.toString(16));
        let dvals = new Uint32Array(4);

        // Modern browsers (IE >=11)
        if (cryptoObject) {
            cryptoObject.getRandomValues(dvals);
        } else {
            // Legacy browsers, pseudo random based on Math.random instead of crypto
            const maxUInt32Value = Math.pow(2, 32) - 1;
            dvals = dvals.map(() => Math.floor(Math.random() * maxUInt32Value));
        }

        const d0 = dvals[0];
        const d1 = dvals[1];
        const d2 = dvals[2];
        const d3 = dvals[3];
        /* tslint:disable */
        return (
            lut[d0 & 0xff] +
            lut[(d0 >> 8) & 0xff] +
            lut[(d0 >> 16) & 0xff] +
            lut[(d0 >> 24) & 0xff] +
            '-' +
            lut[d1 & 0xff] +
            lut[(d1 >> 8) & 0xff] +
            '-' +
            lut[((d1 >> 16) & 0x0f) | 0x40] +
            lut[(d1 >> 24) & 0xff] +
            '-' +
            lut[(d2 & 0x3f) | 0x80] +
            lut[(d2 >> 8) & 0xff] +
            '-' +
            lut[(d2 >> 16) & 0xff] +
            lut[(d2 >> 24) & 0xff] +
            lut[d3 & 0xff] +
            lut[(d3 >> 8) & 0xff] +
            lut[(d3 >> 16) & 0xff] +
            lut[(d3 >> 24) & 0xff]
        );
        /* tslint:enable */
    }

    /**
     * Generate a random ID
     * based on current timestamp + random number
     * in Hexadecimal format
     * note : this is NOT a RFC4122-based UUID
     * @returns {string} Random ID
     */
    public static generateRandomId(): string {
        return '' + Date.now().toString(16) + Math.random().toString(16).slice(-8);
    }

    /**
     * Return the window crypto object (set in a separate method to help testing)
     * @private
     * @returns {Crypto}
     */
    private static getCryptoObject(): Crypto {
        const CRYPTO_PROPERTY = 'crypto';
        const MSCRYPTO_PROPERTY = 'msCrypto';

        return window[CRYPTO_PROPERTY] || window[MSCRYPTO_PROPERTY];
    }
}
